export const copyToClipboard = text => {
  if (window.navigator.clipboard) {
    return window.navigator.clipboard.writeText(text);
  }

  // Fallback logic for older browsers
  return new Promise(resolve => {
    const el = document.createElement('textarea');
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    resolve();
  });
};
export const getProjectTypeURLString = (projectType, simplifiedProject) => {
  switch (projectType) {
    case 'business':
      return 'core';
    case 'service_desk':
      return 'servicedesk';
    case 'software':
      return simplifiedProject ? 'software' : 'software/c';
    default:
      // should never happen, typescript use your typechecking brain pls
      return '';
  }
};